import React from 'react';

// Custom
import useRouting from "@/components/MapRouting/useRouting";
import ProfileChart from "@/ui/Charts/ProfileChart";

const MapRouteProfile = (props: { mode?: 'desktop' | 'mobile' }) => {

  const { routeData, drawPointOnRoute, clearPointOnRoute, generateGraphMarkers } = useRouting({});

  const { mode } = props;

  const handleChartMouseEnter = (e: any, chart: any, options: any) => {
    const ind = options.dataPointIndex;
    const m = chart.data.twoDSeriesX[ind];
    const last = chart.data.twoDSeriesX[chart.data.twoDSeriesX.length - 1];
    const mrel = m / last;

    drawPointOnRoute(mrel);
  };

  const handleChartMouseLeave = (e: any, chart: any, options: any) => {
    clearPointOnRoute();
  };

  const graphMarkers = generateGraphMarkers(routeData?.record);

  const routeLength = routeData ? (routeData.record["total_length"] as number) : 0;

  return (routeData ?
    <ProfileChart
      // @ts-ignore
      series={[
        {
          name: routeData.feature.get("code"),
          data: routeData.feature
            ?.getGeometry()
            ?.getCoordinates()
            .map((c: number[]) => [
              Math.round(c[3] * routeLength),
              Math.round(c[2]),
            ]) as number[][],
        },
      ]}
      markerPoints={graphMarkers}
      onChartMouseEnter={handleChartMouseEnter}
      onChartMouseLeave={handleChartMouseLeave}
      chartId={mode ? `route-profile-chart-${mode}` : 'route-profile-chart'}
    />
    : null);
}

export default MapRouteProfile;
